import { logE } from "@blacknut/logging/dist";
import { DefaultNativeBridge, NativeTarget } from "../NativeBridge";
import { AndroidPeerConnectionWrapper } from "../negotiation";
import { AndroidHTMLVideoElementWrapper, HTMLVideoElementWrappper } from "../play";
declare const android: NativeTarget;

const TAG = "AndroidBridge";

class AndroidNativeBridge extends DefaultNativeBridge {
  private pc?: AndroidPeerConnectionWrapper;
  private video?: AndroidHTMLVideoElementWrapper;

  constructor() {
    super(TAG, android);
  }
  protected handleMessage(data: any) {
    if (super.handleMessage(data)) {
      return true;
    }
    switch (data.key) {
      case "onIceCandidate": {
        this.pc?.__android_onIceCandidate(data.payload);
        return true;
      }
      case "onReady": {
        this.pc?.__android_onReady();
        return true;
      }
      case "onPause": {
        this.pc?.__android_onPause();
        return true;
      }
      case "onResume": {
        this.pc?.__android_onResume();
        return true;
      }
      case "onResize": {
        this.video?.__android_onResize(data.payload);
        return true;
      }
      case "exit": {
        this.exitting = true;
        this.exitCallback?.();
        return true;
      }
      default: {
        logE(TAG, "%o not impletemented", data);
      }
    }
    return false;
  }

  public createPeerConnection(
    config: RTCConfiguration,
    peerId: number,
    streamId: string,
  ) {
    this.pc = new AndroidPeerConnectionWrapper(this, config, peerId, streamId);
    return this.pc;
  }

  public createHTMLVideoElementWrapper(): HTMLVideoElementWrappper {
    this.video = new AndroidHTMLVideoElementWrapper(this);
    return this.video;
  }
}

export { AndroidNativeBridge };
export default AndroidNativeBridge;
